<template>
    <v-container fluid fill-height>
        <loading v-if="loading"></loading>
        <no-data v-else-if="contractorOrganisations.length == 0" message="Unable to load contractor organisations"></no-data>
        <v-layout v-else>
            <v-flex>
                <v-card>
                    <v-layout pa-2>
                        <contractor-export
                            :contractorOrganisations="contractorOrganisations">
                        </contractor-export>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import NoData from '@/components/generic/NoData.vue';
import ContractorExport from '@/components/preceda/ContractorExport.vue'

export default {
    components: {
        Loading,
        NoData,
        ContractorExport
    },
    data(){
        return {
            loading: false
        };
    },
    computed: {
        contractorOrganisations(){
            return this.$store.getters["PrecedaStore/getContractorOrganisations"];
        }
    },
    methods: {
        async loadData(){
            this.loading = true;

            this.$store.dispatch("PrecedaStore/loadContractorOrganisations");

            this.loading = false;
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
